import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { endpointsApi } from "@/lib/api";
import type { EndpointCreate, EndpointUpdate } from "@/types";

export function useEndpoints() {
  return useQuery({
    queryKey: ["endpoints"],
    queryFn: () => endpointsApi.list(),
  });
}

export function useEndpoint(id: string) {
  return useQuery({
    queryKey: ["endpoints", id],
    queryFn: () => endpointsApi.get(id),
    enabled: !!id,
  });
}

export function useCreateEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: EndpointCreate) => endpointsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["endpoints"] }),
  });
}

export function useUpdateEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: EndpointUpdate }) =>
      endpointsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["endpoints"] }),
  });
}

export function useDeleteEndpoint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => endpointsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["endpoints"] }),
  });
}
